export default {
  fishnetFeedsUrl: 'https://av.fn.sportradar.com/',
  fishnetOddsFeedsUrl: 'https://misc.fn.sportradar.com/',
  fishnetFeedsReleaseUrl: 'https://qaweb.feeds.nonprod.euc1.srff.io/',
  fishnetCrestUrl: 'https://img.sportradar.com/ls/crest/[size]/[UID].png',
};
